import React from "react";
import { IUploadFileProps } from "./definitions";
import styles from "./style.module.scss";
import { FileUpload } from "@amzn/awsui-components-react";
import { getFileNameWithoutExtension } from "utils/date-format";

const UploadFile: React.FC<IUploadFileProps> = (props: IUploadFileProps) => {
  const [_name] = React.useState<string>("UploadFile");

  React.useEffect(() => {
    return () => {};
  }, []);

  return (
    <div className={styles.uploadFile} data-testid="upload-file">
      <FileUpload
        onChange={({ detail }) => {
          props.setFiles(detail.value);
          if (props.setFileName) {
            props.setFileName(
              getFileNameWithoutExtension(detail.value[0]?.name),
            );
          }
          if (props.setFileError) {
            props.setFileError(detail.value.length === 0);
          }
        }}
        value={props.files}
        multiple={props.multiple}
        accept={
          ".docm, .pages, .mp4, .xls, .doc, .docx, .xls, .xlsx, .csv, .tsv, .pdf, .jpg, .jpeg, .png, .eml, .ppt, .pptx, .mp4, .zip"
        }
        i18nStrings={{
          uploadButtonText: (e) => (e ? "Browse files" : "Upload"),
          dropzoneText: (e) =>
            e ? "Drop files to upload" : "Drop file to upload",
          removeFileAriaLabel: (e) => `Remove file ${e + 1}`,
          limitShowFewer: "Show fewer files",
          limitShowMore: "Show more files",
          errorIconAriaLabel: "Error",
        }}
        showFileLastModified
        showFileSize
        showFileThumbnail
        tokenLimit={3}
        constraintText={<div>Or drop files here</div>}
      />
    </div>
  );
};

export default UploadFile;
